"use strict";

var LoggerInstance = require("js-logger").get("SearchActions");

var SearchApi = require("../api/SearchApi");

var ActionsHelper = require("../actions/ActionsHelper");

var HistoryHelper = require("../shared/HistoryHelper");

var GridListToggleHelper = require("../designer/components/searchResults/GridListToggleHelper");

// Use the actions off the window to avoid double packaging
// Note: avoiding server-side reference to window
//var ProductActions = window.ProductActions;
//var ProjectActions = window.ProjectActions;

var SearchActions = {
	initializeGridListToggle: function(id, previouslySelectedView) {
		GridListToggleHelper.initializeGridListToggle(id, previouslySelectedView, "searchResults", "grid-search-results-wrapper", "list-search-results-wrapper");
	},

	navigateToTangible: function (isDesignMode, tangibleUrl) {
		if (isDesignMode) {
			return;
		}
		this.recordClicked();
		window.location = tangibleUrl;
	},

	recordClicked: function () {
		var searchInformation = window._lastSearchInformation;
		if (searchInformation) {
			// Only record that results were clicked once per search (at most)
			// Right click in Chrome triggers contextmenu and auxclick and we are setting a bool so we only need once
			delete window._lastSearchInformation;
			SearchApi.recordClicked(searchInformation);
		}
	},

	addToCart: function (isDesignMode, tangibleType, tangibleCode, addAndStay, event) {
		try {
			event = ActionsHelper.getEventOrReturn(event, isDesignMode, "Search Results Navigate or Add To Cart called successfully.", /*preventDefaultInDesignMode*/false);
			if (!event) {
				return;
			}

			var afterSubmit = () => {
				if (!addAndStay) {
					window.location = "/shoppingcart";
				}
			};

			var searchResultsId = $(event.target).closest("[data-component=searchResults]").attr("id");
			var context = `search_${searchResultsId}`;
			switch (tangibleType) {
				case "PRODUCTS":
					window.ProductActions.addToCart(event, context, tangibleCode, afterSubmit);
					break;
				case "PROJECTS":
					window.ProjectActions.addToCart(event, context, tangibleCode, afterSubmit);
					break;
			}
		}
		catch(exception) {
			LoggerInstance.error(exception);
		}
		finally {
			return false;
		}
	},

	resetSearch: function(searchText) {
		var newQueryStringObject = { searchText };
		HistoryHelper.replaceHistoryState(newQueryStringObject);
	},

	handlePopState: function (event) {
		HistoryHelper.handlePopState(/*executeAction*/(currentQueryObject, additionalOptions) => {
			$("[data-component='searchBar.input']").val(currentQueryObject.searchText);
			window._searchText = currentQueryObject.searchText;
			window.search(/*searchResultsId*/null, /*page*/null, currentQueryObject.searchText, /*sort*/null, currentQueryObject.categoryId, additionalOptions);
		}, /*shouldShortCircuit*/(currentQueryObject) => {
			return !currentQueryObject.searchText;
		});
	},

	updateHistoryStateAfterSearch: function (searchText, categoryId, newQueryObject, updateId) {
		searchText = searchText || "";

		HistoryHelper.updateHistoryStateAfterLoad(newQueryObject, updateId, /*afterCreateObjectLogic*/(currentQueryObject) => {
			currentQueryObject.searchText = searchText;
			if (categoryId) {
				currentQueryObject.category = categoryId;
			} else {
				delete currentQueryObject.category;
			}
		});
	}
};

module.exports = SearchActions;
